import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import FormulaireBuilder from './pages/FormulaireBuilder';
import FormulaireResultats from './pages/FormulaireResultats';
import Classes from './pages/Classes';
import ClasseDetail from './pages/ClasseDetail';
import FicheEleve from './pages/FicheEleve';
import FormPublic from './pages/FormPublic';
import FormConfirmation from './pages/FormConfirmation';
import AuthCallback from './pages/AuthCallback';
import Layout from './components/Layout';

function RequireAuth({ children }) {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/s/:code" element={<FormPublic />} />
        <Route path="/merci" element={<FormConfirmation />} />

        {/* Espace enseignant */}
        <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="formulaire/creer" element={<FormulaireBuilder />} />
          <Route path="formulaire/:id/modifier" element={<FormulaireBuilder />} />
          <Route path="formulaire/:id" element={<FormulaireResultats />} />
          <Route path="classes" element={<Classes />} />
          <Route path="classe/:id" element={<ClasseDetail />} />
          <Route path="eleve/:id" element={<FicheEleve />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
